/* Accessibility: announce sold-out sizes/colors to screen readers.
   The theme marks unavailable option inputs with the "is-disabled" class
   (visual strike-through only). This adds hidden "– Sold out" text to the
   matching label so screen readers announce it too, and keeps it in sync
   whenever the shopper changes their selection. */
(function () {
  if (window.__a11ySoldOutLoaded) return;
  window.__a11ySoldOutLoaded = true;

  function soldOutText() {
    var t = window.theme && window.theme.variantStrings && window.theme.variantStrings.soldOut;
    return ' – ' + (t || 'Sold out');
  }

  function sync(picker) {
    if (!picker || !picker.querySelectorAll) return;
    picker.querySelectorAll('fieldset input[type="radio"]').forEach(function (input) {
      if (!input.id) return;
      var label = picker.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (!label) return;
      var note = label.querySelector('.a11y-sold-out');
      var unavailable = input.classList.contains('is-disabled');
      if (unavailable && !note) {
        note = document.createElement('span');
        note.className = 'a11y-sold-out visually-hidden';
        note.textContent = soldOutText();
        label.appendChild(note);
      } else if (!unavailable && note) {
        note.remove();
      }
    });
  }

  customElements.whenDefined('variant-selects').then(function () {
    var VariantSelects = customElements.get('variant-selects');
    var original = VariantSelects.prototype.setDisabled;
    if (original && !original.__a11yPatched) {
      var patched = function () {
        var result = original.apply(this, arguments);
        sync(this);
        return result;
      };
      patched.__a11yPatched = true;
      VariantSelects.prototype.setDisabled = patched;
    }
    // Pickers that already ran setDisabled before this patch loaded
    document.querySelectorAll('variant-selects, variant-radios').forEach(sync);
  });
})();
